import React from 'react';
import '../template-file-css/document-file-template.css';


export const NHBC_Mdt = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NHBC_Mdt' className='file-pdf-document'>

            <div className='file-template'>
                <h4>SECTION II: Participants</h4>
                <table>
                    <tr>
                        <th className='w-250'>Participants' Name</th>
                        <th className='w-250'>Title</th>
                        <th className='w-250'>Signature</th>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id="txtParticipant_1" name="txtParticipant_1" className='add-only' /></td>
                        <td className='w-250'><input type='text' id="txtTitle_1" name="txtTitle_1" className='add-only' /></td>
                        <td className='signature w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id="txtParticipant_2" name="txtParticipant_2" className='add-only' /></td>
                        <td className='w-250'><input type='text' id="txtTitle_2" name="txtTitle_2" className='add-only' /></td>
                        <td className='signature w-250'> &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id="txtParticipant_3" name="txtParticipant_3" className='add-only' /></td>
                        <td className='w-250'><input type='text' id="txtTitle_3" name="txtTitle_3" className='add-only' /></td>
                        <td className='signature w-250'>&nbsp;</td>
                    </tr>
                </table>
                <h4>SECTION III: Placement Recommendations</h4>
                <p className='w-750'>
                    <span className='eleHeader'>(1) Brief detail of child's needs:</span>
                    <textarea id="txtSec3_DetailsOfChild" name="txtSec3_DetailsOfChild" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>(2) Most appropriate type of placement (relative, foster care, group home, institution, etc.):</span>
                    <textarea id="txtSec3_TypeOfPlacement" name="txtSec3_TypeOfPlacement" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>(3) Why this placement is recommended:</span>
                    <textarea id="txtSec3_PlacementrRcommended" name="txtSec3_PlacementrRcommended" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>(4) Will this placement be supported through Wrap-around services? If yes, what services are recommended?</span>
                    <textarea id="txtSec3_WraparoundServices" name="txtSec3_WraparoundServices" className='add-only'></textarea>
                </p>
                <h4>SECTION IV: Permanency Recommendations</h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSec4_Reunification" name="cbSec4" className='add-only' value="Reunification" /> Reunification
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSec4_Adoption" name="cbSec4" className='add-only' value="Adoption" /> Adoption
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSec4_Guardianship" name="cbSec4" className='add-only' value="Guardianship" /> Guardianship
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type="checkbox" id="cbSec4_LivingRelative" name="cbSec4" className='add-only' value="Placement with Fit and Living Relative" /> Placement with Fit and Living Relative
                        </td> 
                    </tr>
                    <tr> 
                        <td className='w-500'>
                            <input type="checkbox" id="cbSec4_AnotherLivingArrangement" name="cbSec4" className='add-only' value="Another Planned Permanent Living Arrangement; Specify" /> Another Planned Permanent Living Arrangement; Specify
                            <input type='text' id="txtSec4_AnotherLivingArrangement" name="txtSec4_AnotherLivingArrangement" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h4>SECTION V: Service Recommendations</h4>
                <p className='w-750'>
                    <span className='eleHeader'>Identified Child</span>
                    <textarea id="txtSec4_IdentifiedChild" name="txtSec4_IdentifiedChild" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Biological Mother/Father/Guardian</span>
                    <textarea id="txtSec4_BiologicalMother" name="txtSec4_BiologicalMother" className='add-only'></textarea>
                </p>
                <h4>SECTION VI: Statement to Parents</h4>
                <p className='w-750'>The following statement is to be read verbatim to parents if they participate in the MDT:</p>
                <p className='w-750'>As a parent of a child in foster care, you have certain rights, including the right to understand
                    the reasons for removal, to participate in planning toward your child's return and to know what
                    you must do to accomplish the changes described in the attached case plan. Foster care is a
                    temporary plan. Your child needs to have a permanent home as soon as possible. Therefore, you
                    and the Department need to work together toward this end. The agency will assist you in your
                    efforts to have your child returned by providing direct services and referral to other agencies.
                    At the same time, the agency will be evaluating your efforts in meeting the stated goals of the
                    case plan. Visitation arrangements and contacts with the case worker are included in the plan.
                    These are also import responsibilities for you to understand and meet.</p>
                <p className='w-750'>The case plan has been discussed with the child and parents as it relates to<br />
                    <input type="checkbox" id="cbCasePlan_Permanency" name="cbCasePlan" className='add-only' value="permanency" /> permanency,<br />
                    <input type="checkbox" id="cbCasePlan_Safety" name="cbCasePlan" className='add-only' value="safety" /> safety, and<br />
                    <input type="checkbox" id="cbCasePlan_WellBeing" name="cbCasePlan" className='add-only' value="well being" /> well
                    being (health, education, and mental needs being met while in care) of the child.</p>

                <h4>SECTION VII: Service Level <span className='small'>(check all that apply)</span></h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSec4ServiceLevel_Basic" name="cbSec4ServiceLevel" className='add-only' value="(1) Basic" /> (1) Basic
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSec4ServiceLevel_BasicWraparound" name="cbSec4ServiceLevel" className='add-only' value="" /> (2) Basic + (Wraparound)
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSec4ServiceLevel_LevelOfCareMed" name="cbSec4ServiceLevel" className='add-only' value="" /> (3A) Level of Care-Med. Fragile
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type="checkbox" id="cbSec4ServiceLevel_LevelOfCareEmotional" name="cbSec4ServiceLevel" className='add-only' value="" /> (3B) Level of Care - Emotional/Behavioral Issues
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSec4ServiceLevel_MATCH" name="cbSec4ServiceLevel" className='add-only' value="(4) MATCH" /> (4) MATCH
                        </td>
                    </tr>
                </table>

                <h4>SECTION VIII: Signature</h4>
                <table>
                    <tr>
                        <td className='signature w-300'>&nbsp;</td>
                        <td className='signature w-300'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-300'>Name of Person Completing Form</td>
                        <td className='small w-300'>Title/Agency</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                </table>
            </div>
        </form>

    )
} 
